import { useNavigate } from "react-router-dom";
import SubscribeAccessCard from "../../../components/SubscribeAccessCard";

const SubscribeUnblurOverlay = ({
  title = "Unlock market data",
  description = "Subscribe for live trade flash, full time & sales, and complete market data tools.",
  compact = true,
}) => {
  const navigate = useNavigate();

  const goToPayment = () => {
    navigate("/payment");
  };

  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex w-full max-w-full items-start justify-center overflow-x-hidden px-3 pt-3 sm:px-4 sm:pt-4">
      <SubscribeAccessCard
        title={title}
        description={description}
        onSubscribeNow={goToPayment}
        compact={compact}
      />
    </div>
  );
};

export default SubscribeUnblurOverlay;
